<script setup lang="ts">
import { ref, computed } from 'vue'
import { useAppStore } from '@/stores/AppStore'
import { setPatientLanguage } from '@/i18n'

const languages = [
  { value: 'th', code: 'ไทย', label: 'ไทย', countryCode: 'TH' },
  { value: 'en', code: 'ENG', label: 'English', countryCode: 'GB' },
  { value: 'cn', code: 'CN', label: '中文', countryCode: 'CN' },
]

function flagUrl(countryCode: string) {
  return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`
}

const appStore = useAppStore()
const open = ref(false)

const currentLanguage = computed(() => languages.find(l => l.value === appStore.language) ?? languages[0])

function selectLanguage(lang: string) {
  open.value = false
  setPatientLanguage(lang)
}
</script>

<template>
  <v-menu
    v-if="!appStore.isXpress"
    v-model="open"
    :close-on-content-click="false"
    location="bottom end"
    transition="scroll-y-transition"
  >
    <template #activator="{ props: menuProps }">
      <button
        v-bind="menuProps"
        type="button"
        data-cy="language-button"
        class="tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2 tw-rounded-full tw-border tw-border-gray-200 tw-bg-white tw-shadow-sm tw-select-none tw-outline-none"
      >
        <img
          :src="flagUrl(currentLanguage.countryCode)"
          :alt="currentLanguage.label"
          class="tw-w-[20px] tw-h-[20px] tw-rounded-full tw-object-cover tw-shrink-0"
        />

        <span class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-tracking-wide">
          {{ currentLanguage.code }}
        </span>

        <span class="tw-flex tw-items-center tw-justify-center tw-rounded-full bg-primary2 tw-shrink-0">
          <v-icon :icon="open ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="white" size="18" />
        </span>
      </button>
    </template>

    <v-list rounded="lg" elevation="3" class="tw-min-w-[9rem] tw-py-1" density="compact">
      <v-list-item
        v-for="lang in languages"
        :key="lang.value"
        :value="lang.value"
        :active="lang.value === appStore.language"
        color="primary"
        rounded="lg"
        class="tw-mx-1"
        @click="selectLanguage(lang.value)"
      >
        <template #prepend>
          <img :src="flagUrl(lang.countryCode)" class="tw-w-5 tw-h-auto tw-rounded-sm tw-mr-2" :alt="lang.label" />
        </template>
        <v-list-item-title class="tw-text-sm">{{ lang.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
